<template>
    <el-col :xs="{span:24}" :md="width" v-show="show">
        <el-form-item 
            :class="className"
            :label="displayName" 
            :prop="name"
            :rules="rules">
            <input :name="fieldName" :value="data[name]" hidden="hidden">
            <el-switch 
                    v-if = "isSwitch"
                    :disabled="disabled"
                    v-model="data[name]"
                    active-color="#13ce66"
                    inactive-color="#ff4949">
            </el-switch>
            <el-checkbox 
                    v-else
                    v-model="data[name]" 
                    :disabled="disabled">
            </el-checkbox>
            <div class="hint"><i>{{ hint }}</i></div> 
        </el-form-item>
    </el-col>
</template>

<script>
    import baseBooleanField from "./BaseBooleanField" 
    export default{
        name:"BooleanField",
        mixins:[baseBooleanField]
    }
</script>